import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";

import { FuseConfigService } from "@fuse/services/config.service";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";

import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { locale as translationEnglish } from "./i18n/en";
import { locale as translationRussian } from "./i18n/ru";

import { DataService } from "../../services/data.service";
import { UserModel } from "../../models/user.model";
import { AclService } from "ng2-acl/dist";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { MatDialog, MatDialogRef } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "fuse-toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.scss"],
})
export class FuseToolbarComponent implements OnDestroy, OnInit {
  userStatusOptions: any[];
  languages: any;
  selectedLanguage: any;
  showLoadingBar: boolean;
  horizontalNav: boolean;
  noNav: boolean;
  user: UserModel = new UserModel();
  remindersCount = 0;
  shakeBell = false;
  onLine = false;
  loggedIdSub: Subscription;
  adminCommands = [];
  isAdmin = false;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  translationObj: any = {};

  messageCount = 0;

  constructor(
    private router: Router,
    private fuseConfig: FuseConfigService,
    private sidebarService: FuseSidebarService,
    private dataService: DataService,
    private fuseTranslationLoader: FuseTranslationLoaderService,
    private aclService: AclService,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.fuseTranslationLoader.loadTranslations(
      translationEnglish,
      translationRussian
    );
    this.translate.get("COMMANDS").subscribe((res) => {
      this.translationObj = res;
    });
    this.getUser();
    this.dataService.remindersCount.subscribe((reminder) => {
      this.remindersCount = reminder.count;
      if (reminder.shake) {
        this.shakeReminder();
      }
    });
    this.dataService.newLeadQueue.subscribe((res) => {
      this.onLine = res.state === "subscribed";
    });
    this.loggedIdSub = this.dataService.isLoggedIn.subscribe((loggedId) => {
      if (loggedId) {
        this.dataService.checkLeadQueueState().subscribe((res: any) => {
          if (res && !res.errors && this.user.responsibleFor === "leads") {
            this.dataService.newLeadQueue.next(res.data);
          }
        });

        this.isAdmin = this.user.id === 1;
        if (this.isAdmin) {
          this.dataService.getAdminCommands().subscribe((res: any) => {
            if (res && !res.errors) {
              this.adminCommands = res.data.commands;
            }
          });
        }
      }
    });

    this.languages = [
      {
        id: "en",
        title: "English",
        flag: "us",
      },
      {
        id: "ru",
        title: "Русский",
        flag: "ru",
      },
    ];

    this.selectedLanguage = this.languages.find(
      (lang) => lang.id === this.dataService.getCurrentLang()
    );

    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showLoadingBar = true;
      }
      if (event instanceof NavigationEnd) {
        this.showLoadingBar = false;
      }
    });

    this.fuseConfig.onConfigChanged.subscribe((settings) => {
      this.horizontalNav = settings.layout.navigation === "top";
      this.noNav = settings.layout.navigation === "none";
    });
    this.dataService.updateAvatar.subscribe((res) => {
      if (res) {
        this.getUser();
      }
    });

    this.dataService.isLoggedIn.subscribe((loggedId) => {
      if (loggedId) {
      }
    });
  }

  ngOnInit() {}

  execAdminCmd(cmd) {
    console.log(cmd);
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false,
    });

    this.confirmDialogRef.componentInstance.confirmMessage =
      this.translationObj.EXEC_QUESTION;
    this.confirmDialogRef.componentInstance.okTBtn = this.translationObj.EXEC;
    this.confirmDialogRef.componentInstance.cancelBtn =
      this.translationObj.CANCEL;
    this.confirmDialogRef.componentInstance.confirmTitle =
      this.translationObj.EXEC_COMMAND;

    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataService.execAdminCommand(cmd).subscribe((res: any) => {
          if (res && !res.errors) {
            this.dataService.showAlert.next({
              type: "success",
              message: this.translationObj.EXEC_SUCCESS,
            });
          } else {
            this.dataService.showAlert.next({
              type: "danger",
              message: this.translationObj.EXEC_ERROR,
            });
          }
        });
      }
      this.confirmDialogRef = null;
    });
  }

  toggleOnline() {
    this.dataService.userOnline.next(this.onLine);
  }

  getUser() {
    this.user = new UserModel(this.dataService.getProfileData());
  }

  toggleSidebarOpened(key) {
    this.sidebarService.getSidebar(key).toggleOpen();
  }

  setLanguage(lang) {
    if (this.selectedLanguage !== lang) {
      this.dataService.clearFieldList();
      this.dataService.clearFieldListLegal();
      this.selectedLanguage = lang;
      this.dataService.setLocale(lang.id, true);
      location.reload();
    }
  }

  logOut() {
    this.dataService.logout();
  }

  shakeReminder() {
    this.shakeBell = true;
    // console.log('shakeReminder !!!');
    setTimeout(() => {
      this.shakeBell = false;
    }, 1000);
  }

  ngOnDestroy() {
    this.loggedIdSub.unsubscribe();
  }

  hasAccess(access) {
    return this.aclService.can(access);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/toolbar/toolbar.component.ts